export default [
    'ShoppingCart.persist',
    'ShoppingCart.persistState',
    'ShoppingCart.selectedPlansMap0',
    'SignUp.account',
    'SignUp.zuoraInfo',
    'SignUp.agreements',
    'ShoppingCart.currentEditPlan',
    'Coupon.couponState',
    'Coupon.verifyCouponStatus',
];
